import { restrictedAccess } from '../middleware'

export default {
  path: '/project-codes',
  component: () => import('@/views/admin/project-codes/Index'),
  beforeEnter: restrictedAccess(5),
}